import { render, staticRenderFns } from "./GlobalSalesCard.vue?vue&type=template&id=01a83d48"
import script from "./GlobalSalesCard.vue?vue&type=script&lang=js"
export * from "./GlobalSalesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports